import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { fromSecondsToMilliseconds } from '@cbridge-utils/shared-helpers';
import { SymbolAction } from '../symbol.action';

type IDependencies = IClientApiDependencySegment;

export const updateSymbolEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolAction.update.started),
  mergeMap((params) => {
    return dependencies.api.updateSymbol({
      symbolId: params.symbolId,
      symbolGroup: params.symbolGroup,
      pricingTimeout: fromSecondsToMilliseconds(params.pricingTimeout),
      throttlingInterval: params.throttlingInterval ?? undefined,
      scheduleId: params.scheduleId,
    }).pipe(
      mergeMap(() => {
        return [
          SymbolAction.update.done({ params }),
        ];
      }),
      catchApiError((error) => {
        return [
          SymbolAction.update.failed({ params, error: null }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
